module.exports = __webpack_public_path__ + "img/blog-3.8e2aae26.webp";